import React, { useContext } from 'react';
import AuthContext from '../context/AuthContext';
import { useSidebar } from '../context/SidebarContext';
import { Link } from 'react-router-dom';

function Homepage() {
  const { user } = useContext(AuthContext);
  const { sidebarVisible } = useSidebar();

  const isAuthenticated = !!user;
  
  // Vérifier si l'utilisateur a des permissions d'administration
  const hasAdminPermissions = user && (
    user.is_super_admin || 
    user.permissions?.includes("VIEW_DASHBOARD") || 
    user.permissions?.includes("VIEW_PRESENCE") || 
    user.permissions?.includes("VIEW_EMPLOYE") || 
    user.permissions?.includes("VIEW_STATISTICS") || 
    user.permissions?.includes("VIEW_JUSTIFICATION") || 
    user.permissions?.includes("VIEW_PENALITE") || 
    user.permissions?.includes("VIEW_PRIME") || 
    user.permissions?.includes("VIEW_POINTAGE_MANUEL") || 
    user.permissions?.includes("VIEW_CONFIGURATION")
  );

  const showSidebar = isAuthenticated && sidebarVisible && hasAdminPermissions;

  return (
    <div style={{ marginLeft: showSidebar ? '250px' : '0', transition: 'margin-left 0.3s ease' }}>
      <main style={{
        backgroundImage: 'url(https://img.freepik.com/photos-premium/equipe-jeunes-africains-au-bureau-table-ordinateur-portable_219728-4569.jpg?w=996)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        color: 'white',
        padding: '100px 20px',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
      }}>
        <div className="position-absolute top-0 start-0 w-100 h-100" style={{
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1
        }}></div>

        {/* Contenu principal */}
        <div style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
          <h1 className="fw-bold display-4">Plateforme de Gestion RH</h1>
          <p className="lead">Pointage et suivi des employés en toute simplicité</p>

          <h2 className="fw-bold mt-4">Gérez efficacement vos employés</h2>
          <p className="mb-4">
            Une solution simple et efficace pour optimiser la gestion du temps de travail.
          </p>

          <h3 className="fw-bold mb-4">Fonctionnalités clés</h3>
          <ul className="list-unstyled">
            <li className="mb-2"><span className="text-success">✔</span> Accès sécurisé</li>
            <li className="mb-2"><span className="text-success">✔</span> Pointage rapide</li>
            <li className="mb-2"><span className="text-success">✔</span> Suivi en temps réel</li>
            <li className="mb-2"><span className="text-success">✔</span> Rapports automatiques</li>
          </ul>

          {/* Bouton vers page d'infos */}
          <Link 
            to="/about" 
            className="btn btn-success btn-lg mt-4 d-flex align-items-center justify-content-center gap-2 shadow-lg px-4 py-2"
            style={{
              borderRadius: "50px",
              fontWeight: "600",
              fontSize: "1.1rem",
              transition: "all 0.3s ease-in-out"
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.05)";
              e.target.style.boxShadow = "0px 6px 18px rgba(0, 128, 0, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
              e.target.style.boxShadow = "0px 4px 12px rgba(0, 128, 0, 0.3)";
            }}
          >
            <i className="fas fa-info-circle"></i> En savoir plus / Nous contacter
          </Link>

        </div>
      </main>
    </div>
  );
}

export default Homepage;